import React, { useContext, useState } from 'react'
import styles from './styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import { Checkbox, Input, Textarea } from '../../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../../components/ModalFooter/ModalFooter'
import { EducationalStructureContext } from '../../../utils/context'
import { createChildren, updateEducationalStructuresDepartmentsInfo, getPositionHistory } from '../../../actions/educationalStructure'
import PositionHistoryModal from '../PositionHistoryModal'

const validationSchema = Yup.object({
  name: Yup.string().required('Укажите название'),
})

export default function Main() {
  const dispatch = useDispatch()
  const { teachers } = useSelector(state => state.common)
  const { positionHistory } = useSelector(state => state.educational_structure)

  const { closeModal, modalOpen } = useContext(EducationalStructureContext)
  const { addMode = false, did, owner_did } = modalOpen || {}

  const [historyOpen, setHistoryOpen] = useState(false)
  const [saving, setSaving] = useState(false)

  const handleCreate = async (values) => {
    setSaving(true)
    let ok = false
    try {
      ok = await dispatch(createChildren(!values?.owner_did ? { ...values, owner_did } : values))
    } finally {
      setSaving(false)
      if (ok) closeModal()
    }
  }

  const handleUpdate = async (values) => {
    setSaving(true)
    let ok = false
    try {
      ok = await dispatch(updateEducationalStructuresDepartmentsInfo(values))
    } finally {
      setSaving(false)
      if (ok) closeModal()
    }
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleBlur,
    handleChange,
    setFieldValue,
    handleSubmit,
  } = useFormik({
    initialValues: addMode
      ? {
          name: '',
          role: 0,
          mid: 0,
          info: '',
          is_cycle: 0,
          is_boss: 0,
          is_position: 0,
          category: '',
          code: '',
          owner_did: did,
        }
      : {
          ...modalOpen,
          mid: modalOpen?.mid || 0,
          is_cycle: modalOpen?.is_cycle || 0,
          is_boss: modalOpen?.is_boss || 0,
          is_position: modalOpen?.is_position || 0,
          category: modalOpen?.category || '',
          code: modalOpen?.code || '',
        },
    enableReinitialize: true,
    validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate,
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  const handleHistoryClick = () => {
    if (did) {
      dispatch(getPositionHistory(did))
      setHistoryOpen(true)
    }
  }

  return (
    <>
      <div className={styles.modalMain}>
        <div className={`${styles.tabWrapper} ${styles.mainForm}`}>

          {/* Код + Категория */}
          <div className={styles.mainFormRow}>
            <div className={styles.fieldCode}>
              <Input label='Код' name='code' value={values?.code || ''} onChange={handleChange} />
            </div>
            <div className={styles.fieldGrow}>
              <Input label='Категория' name='category' value={values?.category || ''} onChange={handleChange} placeholder='введите категорию' />
            </div>
          </div>

          {/* Название */}
          <div className={styles.mainFormRow}>
            <div className={styles.fieldFull}>
              <Input label='Название' name='name' value={values?.name || ''} error={error('name')} onChange={handleChange} />
            </div>
          </div>

          {/* Чекбоксы */}
          <div className={styles.checkboxGroup}>
            <Checkbox label='Это цикл обучения' checked={!!values?.is_cycle} onChange={() => setFieldValue('is_cycle', values?.is_cycle ? 0 : 1)} name='is_cycle' />
            <Checkbox label='Начальник курса' checked={!!values?.is_boss} onChange={() => setFieldValue('is_boss', values?.is_boss ? 0 : 1)} name='is_boss' />
            <Checkbox label='Это должность' checked={!!values?.is_position} onChange={() => setFieldValue('is_position', values?.is_position ? 0 : 1)} name='is_position' />
          </div>

          {/* Должность занимает */}
          <div className={styles.mainFormRow}>
            <div className={styles.fieldFull}>
              <label className={styles.fieldLabel}>Должность занимает</label>
              <select name='mid' value={values?.mid || ''} onChange={handleChange} className={styles.selectField}>
                <option value=''>—</option>
                {teachers?.map(p => (
                  <option key={p.mid} value={p.mid}>
                    {p.calc_fio}
                  </option>
                ))}
              </select>
            </div>
            <button type='button' onClick={handleHistoryClick} className={styles.historyButton} title='История назначений' disabled={!did}>
              <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' width='18' height='18'>
                <rect x='3' y='4' width='18' height='17' rx='2'/>
                <path d='M3 9h18M8 2v4M16 2v4'/>
              </svg>
            </button>
          </div>

          {/* Описание */}
          <div className={styles.mainFormRow}>
            <div className={styles.fieldFull}>
              <Textarea style={{ resize: 'vertical', minHeight: '110px' }} label='Описание' value={values?.info || ''} name='info' onChange={handleChange} />
            </div>
          </div>

        </div>
      </div>

      <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} loading={saving} />

      {historyOpen && (
        <PositionHistoryModal
          history={positionHistory}
          onClose={() => setHistoryOpen(false)}
        />
      )}
    </>
  )
}
